
<div class="flex flex-wrap content-start gap-[8px] cursor-pointer" (click)="openTrustpilot()">
  <img
    class="h-[28px] w-[150px]"
    height="28"
    width="150"
    src="https://xgrit-ecom.imgix.net/ace/trustpilot-star-rating.svg?v=1706889351"
    alt="Trustpilot Star Rating"
    />
  @if (trustpilotVerified) {
    <div class="flex items-center text-xs xxsm:text-sm xs:text-base">
      <span class="mr-2.5"
        ><span class="font-extrabold">{{ trustpilotTrustScore }}/5</span> Stars</span
        >
      <span
        ><span class="font-extrabold">{{ trustpilotNumberOfReviews | number }}</span> Reviews</span
        >
    </div>
  }
</div>
